import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentClone = () => {
  return (
    <g>
      <path d="m14.5185 3.2832h-2.356v-2.3555a.75.75 0 0 0 -.75-.75h-6.2836a.7608.7608 0 0 0 -.53.22l-3.6477 3.6472a.7608.7608 0 0 0 -.22.53v7.3916a.75.75 0 0 0 .75.75h2.3562v2.3555a.75.75 0 0 0 .75.75h9.9312a.75.75 0 0 0 .75-.75v-11.0388a.75.75 0 0 0 -.7501-.75zm-9.9546-.73v1.4568h-1.4565zm-2.3325 2.9568h3.0826a.75.75 0 0 0 .75-.75v-3.0823h4.5986v9.5391h-8.4312zm11.5371 8.8125h-8.4311v-1.6057h6.0752a.75.75 0 0 0 .75-.75v-7.1836h1.606z" />
    </g>
  );
};

export default withIcon(IconDocumentClone);
